import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobs } from "../../features/jobs/jobsSlice";
import Job from "./Job";

const Jobs = () => {
  const dispatch = useDispatch();
  const { isLoading, isError, error, jobs } = useSelector(
    (state) => state.jobs
  );
  const { status, searchTerm, sortBy } = useSelector((state) => state.filters);

  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch]);

  

  // logic for search feature
  const filterJobsBySearchTerm = (job) => {
    if (job.title.toLowerCase().includes(searchTerm.toLowerCase())) {
      return true;
    }
  };

  // logic for sorting jobs by salary
  const SortJobs = (jobA, jobB) => {
    const a = Number(jobA.salary);
    const b = Number(jobB.salary);
    switch (sortBy) {
      case "Salary (Low to High)":
        return a - b;
      case "Salary (High to Low)":
        return b - a;
      default:
        return 0;
    }
  };

  // logic for filtering jobs by Job Category
  const filterByStatus = (job) => {
    switch (status) {
      case "Internship":
        return job.type === "Internship";
      case "Full Time":
        return job.type === "Full Time";
      case "Remote":
        return job.type === "Remote";
      default:
        return true;
    }
  };

  let content = null;

  if (isLoading) content = <p>Loading...</p>;

  if (!isLoading && isError) content = <p>{error}</p>;

  if (!isLoading && !isError && jobs.length === 0)
    content = <p>No Jobs Found!</p>;

  if (!isLoading && !isError && jobs.length > 0) {
    content = jobs
      .filter(filterByStatus)
      .filter(filterJobsBySearchTerm)
      .sort(SortJobs)
      .map((job) => <Job key={job.id} job={job} />);
  }

  return (
    <div className="jobs-list">
      {/* <!-- Single Job 1--> */}
      {content}
      {/* <!-- Single Job 1--> */}
    </div>
  );
};

export default Jobs;
